export default "__VITE_ASSET__CDnXLNCi__"